// @ts-nocheck
import {
    HeaderContext,
    HeaderContextModel,
    HeaderStickyLevels,
} from "@store/Framework/Components/Header/HeaderContext/HeaderContext";
import React, { FC, useState } from "react";

const HeaderContextProvider: FC = ({ children }) => {
    const [headerLevel, setHeaderLevel] = useState<HeaderStickyLevels>(HeaderStickyLevels.normal);

    const providerValue: HeaderContextModel = {
        headerLevel,
        setHeaderLevel,
    };

    return <HeaderContext.Provider value={providerValue}>{children}</HeaderContext.Provider>;
};

export default HeaderContextProvider;
